@if (!(shwmsg)) {
<div class="page-header">
  <div class="row align-items-md-center">
    <div class="col-md-10">
      <div class="row hdrBar">
        @if (fltrsdata.length) {
        <div class="col-lg-12 col-md-12 mg-a">
          <h1>{{ fltrsdata[0].rpt_nm }}</h1>
          <span class="text-gray font-size-13">{{
            fltrsdata[0].rpt_desc
          }}</span>
        </div>
        }
      </div>
    </div>
    <div class="col-md-2" style="margin: auto">
      <div class="text-md-right m-v-10">
        <button
          nz-button
          nzType="default"
          (click)="goBack()"
          style="
            box-shadow: 0 4px 12px 0 rgb(123 149 153 / 24%);
            color: #1969cd;
            font-weight: 500;
            float: right;
          "
        >
          <i nz-icon nzType="left"></i> Go back
        </button>
      </div>
    </div>
  </div>
</div>
} @if (!(shwmsg) && fltrsdata.length) {
<div>
  @if (fltrsdata && fltrsdata[0].fltr_id != null) {
  <div class="filter-card">
    <div class="input-row" nz-row nzXs="6" nzSm="4" nzMd="4" nzLg="4" nzXl="4">
      <div nz-row nzLayout.xs="column" nzFlexFill>
        @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 31 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 31 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 31 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 31 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 31 ) || (
        fltrsdata[5] && fltrsdata[5].fltr_id == 31 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 31 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 31 )|| ( fltrsdata[8] && fltrsdata[8].fltr_id == 31 ) || (
        fltrsdata[9] && fltrsdata[9].fltr_id == 31 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 31 )||( fltrsdata[11] && fltrsdata[11].fltr_id
        == 31 ) || ( fltrsdata[12] && fltrsdata[12].fltr_id == 31 ) || (
        fltrsdata[13] && fltrsdata[13].fltr_id == 31 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 31 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 31 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 31 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 31 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 31 )|| ( fltrsdata[19] && fltrsdata[19].fltr_id
        == 31 ) || ( fltrsdata[20] && fltrsdata[20].fltr_id == 31 ) || (
        fltrsdata[21] && fltrsdata[21].fltr_id == 31 ))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">District</div>
            <nz-select
              nzShowSearch
              [(ngModel)]="slctdDstrct"
              nzPlaceHolder="Choose"
              [nzMaxTagCount]="1"
              (ngModelChange)="onCnstyChange($event)"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
            >
              <!-- <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option> -->
              @for (d of dstrtLst; track d) {
              <nz-option [nzValue]="d.dstrct_id" [nzLabel]="d.dstrct_nm">
                {{ d.dstrct_nm }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 26 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 26 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 26 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 26 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 26 ) || (
        fltrsdata[5] && fltrsdata[5].fltr_id == 26 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 26 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 26 ) || ( fltrsdata[8] && fltrsdata[8].fltr_id == 26 ) || (
        fltrsdata[9] && fltrsdata[9].fltr_id == 26 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 26 ) || ( fltrsdata[11] &&
        fltrsdata[11].fltr_id == 26 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 26 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 26 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 26 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 26 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 26 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 26 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 26 ) || ( fltrsdata[19] &&
        fltrsdata[19].fltr_id == 26 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 26 ))) {
        <div nzFlex="30" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Vendor</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectVndr"
              nzPlaceHolder="Choose"
              (ngModelChange)="onVndrChange($event)"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="Vendor is required!"
            >
              @if (!showVndr) {
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              } @for (v of vendorList; track v) {
              <nz-option
                [nzValue]="v.vndr_id"
                [nzLabel]="v.vndr_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 24 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 24 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 24 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 24 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 24 ) || (
        fltrsdata[5] && fltrsdata[5].fltr_id == 24 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 24 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 24 ) || ( fltrsdata[8] && fltrsdata[8].fltr_id == 24 )|| (
        fltrsdata[9] && fltrsdata[9].fltr_id == 24 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 24 ) || ( fltrsdata[11] &&
        fltrsdata[11].fltr_id == 24 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 24 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 24 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 24 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 24 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 24 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 24 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 24 ) || ( fltrsdata[19] &&
        fltrsdata[19].fltr_id == 24 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 24 ) ) && showUlbFltr==true) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select ULB</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedtenant"
              nzPlaceHolder="Choose"
              [nzMaxTagCount]="1"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
              (ngModelChange)="onULBChange($event)"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (u of ulbLst; track u) {
              <nz-option [nzValue]="u.tnt_id" [nzLabel]="u.tnt_nm"
                >{{ u.tnt_nm }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 2000004 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 2000004 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 2000004 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 2000004 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 2000004 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 2000004 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 2000004 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 2000004 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 2000004 ) || ( fltrsdata[9] &&
        fltrsdata[9].fltr_id == 2000004 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 2000004 ) || ( fltrsdata[11] &&
        fltrsdata[11].fltr_id == 2000004 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 2000004 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 2000004 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 2000004 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 2000004 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 2000004 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 2000004 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 2000004 ) || ( fltrsdata[19] &&
        fltrsdata[19].fltr_id == 2000004 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 2000004 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Constituency</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="slctCnsty"
              nzPlaceHolder="Choose Constituency"
              [nzMaxTagCount]="1"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
              (ngModelChange)="onPlngStnChange($event)"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (c of cnstyList; track c) {
              <nz-option [nzValue]="c.cnsty_id" [nzLabel]="c.cnsty_nm"
                >{{ c.cnsty_nm }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 2000005 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 2000005 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 2000005 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 2000005 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 2000005 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 2000005 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 2000005 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 2000005 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 2000005 ) || ( fltrsdata[9] &&
        fltrsdata[9].fltr_id == 2000005 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 2000005 ) || ( fltrsdata[11] &&
        fltrsdata[11].fltr_id == 2000005 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 2000005 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 2000005 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 2000005 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 2000005 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 2000005 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 2000005 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 2000005 ) || ( fltrsdata[19] &&
        fltrsdata[19].fltr_id == 2000005 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 2000005 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Polling Station</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="slctPlngStn"
              nzPlaceHolder="Choose Polling Station"
              [nzMaxTagCount]="1"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (p of plngStnList; track p) {
              <nz-option [nzValue]="p.plng_stn_id" [nzLabel]="p.plng_stn_nm"
                >{{ p.plng_stn_nm }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 24 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 24 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 24 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 24 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 24 ) || (
        fltrsdata[5] && fltrsdata[5].fltr_id == 24 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 24 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 24 ) || ( fltrsdata[8] && fltrsdata[8].fltr_id == 24 ) || (
        fltrsdata[9] && fltrsdata[9].fltr_id == 24 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 24 ) || ( fltrsdata[11] &&
        fltrsdata[11].fltr_id == 24 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 24 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 24 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 24 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 24 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 24 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 24 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 24 ) || ( fltrsdata[19] &&
        fltrsdata[19].fltr_id == 24 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 24 ) ) && showUlbFltr!=true) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">ULB</div>
            <div class="form-label disbledtxt">{{ ulbLst[0].tnt_nm }}</div>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 5 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 5 ) || ( fltrsdata[2] && fltrsdata[2].fltr_id
        == 5 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id == 5 ) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 5 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 5 ) || ( fltrsdata[6] && fltrsdata[6].fltr_id ==
        5 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id == 5 ) || ( fltrsdata[8]
        && fltrsdata[8].fltr_id == 5 ) || ( fltrsdata[9] && fltrsdata[9].fltr_id
        == 5 ) || ( fltrsdata[10] && fltrsdata[10].fltr_id == 5 ) || (
        fltrsdata[11] && fltrsdata[11].fltr_id == 5 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 5 ) || ( fltrsdata[13] && fltrsdata[13].fltr_id
        == 5 ) || ( fltrsdata[14] && fltrsdata[14].fltr_id == 5 ) || (
        fltrsdata[15] && fltrsdata[15].fltr_id == 5 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 5 ) || ( fltrsdata[17] && fltrsdata[17].fltr_id
        == 5 ) || ( fltrsdata[18] && fltrsdata[18].fltr_id == 5 ) || (
        fltrsdata[19] && fltrsdata[19].fltr_id == 5 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 5 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Ward</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectWrd"
              nzPlaceHolder="Choose"
              [nzMaxTagCount]="1"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (w of wardsLst; track w) {
              <nz-option [nzValue]="w.wrd_id" [nzLabel]="w.wrd_nm"
                >{{ w.wrd_nm }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 16 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 16 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 16 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 16 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 16 )|| (
        fltrsdata[5] && fltrsdata[5].fltr_id == 16 )|| ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 16 )|| ( fltrsdata[7] && fltrsdata[7].fltr_id ==
        16 )|| ( fltrsdata[8] && fltrsdata[8].fltr_id == 16 )|| ( fltrsdata[9]
        && fltrsdata[9].fltr_id == 16 )|| ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 16 )|| ( fltrsdata[11] && fltrsdata[11].fltr_id
        == 16 )|| ( fltrsdata[12] && fltrsdata[12].fltr_id == 16 )|| (
        fltrsdata[13] && fltrsdata[13].fltr_id == 16 )|| ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 16 )|| ( fltrsdata[15] && fltrsdata[15].fltr_id
        == 16 )|| ( fltrsdata[16] && fltrsdata[16].fltr_id == 16 )|| (
        fltrsdata[17] && fltrsdata[17].fltr_id == 16 )|| ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 16 )|| ( fltrsdata[19] && fltrsdata[19].fltr_id
        == 16 )|| ( fltrsdata[20] && fltrsdata[20].fltr_id == 16 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Employe</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectUsr"
              nzPlaceHolder="Choose"
              [nzMaxTagCount]="1"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
            >
              @for (w of usrLst; track w) {
              <nz-option [nzValue]="w.usr_id" [nzLabel]="w.usr_nm"
                >{{ w.usr_nm }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 17 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 17 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 17 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 17 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 17 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box" style="margin: 0 17px 0px 0">
            <div class="form-label">Enter Delay Days</div>
            <input
              type="number"
              placeholder="Days"
              nz-input
              [(ngModel)]="dlyDys"
            />
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 6 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 6 ) || ( fltrsdata[2] && fltrsdata[2].fltr_id
        == 6 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id == 6 ) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 6 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 6 ) || ( fltrsdata[6] && fltrsdata[6].fltr_id ==
        6 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id == 6 ) || ( fltrsdata[8]
        && fltrsdata[8].fltr_id == 6 ) || ( fltrsdata[9] && fltrsdata[9].fltr_id
        == 6 ) || ( fltrsdata[10] && fltrsdata[10].fltr_id == 6 ) || (
        fltrsdata[11] && fltrsdata[11].fltr_id == 6 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 6 ) || ( fltrsdata[13] && fltrsdata[13].fltr_id
        == 6 ) || ( fltrsdata[14] && fltrsdata[14].fltr_id == 6 ) || (
        fltrsdata[15] && fltrsdata[15].fltr_id == 6 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 6 ) || ( fltrsdata[17] && fltrsdata[17].fltr_id
        == 6 ) || ( fltrsdata[18] && fltrsdata[18].fltr_id == 6 ) || (
        fltrsdata[19] && fltrsdata[19].fltr_id == 6 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 6 ) || ( fltrsdata[21] && fltrsdata[21].fltr_id
        == 6 ) || ( fltrsdata[0] && fltrsdata[0].fltr_id == 4 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 4 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 4 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id ==
        4 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 4 ) || ( fltrsdata[5]
        && fltrsdata[5].fltr_id == 4 ) || ( fltrsdata[6] && fltrsdata[6].fltr_id
        == 4 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id == 4 ) || (
        fltrsdata[8] && fltrsdata[8].fltr_id == 4 ) || ( fltrsdata[9] &&
        fltrsdata[9].fltr_id == 4 ) || ( fltrsdata[10] && fltrsdata[10].fltr_id
        == 4 ) || ( fltrsdata[11] && fltrsdata[11].fltr_id == 4 ) || (
        fltrsdata[12] && fltrsdata[12].fltr_id == 4 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 4 ) || ( fltrsdata[14] && fltrsdata[14].fltr_id
        == 4 ) || ( fltrsdata[15] && fltrsdata[15].fltr_id == 4 ) || (
        fltrsdata[16] && fltrsdata[16].fltr_id == 4 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 4 ) || ( fltrsdata[18] && fltrsdata[18].fltr_id
        == 4 ) || ( fltrsdata[19] && fltrsdata[19].fltr_id == 4 ) || (
        fltrsdata[20] && fltrsdata[20].fltr_id == 4 ) || ( fltrsdata[21] &&
        fltrsdata[21].fltr_id == 4 ))) {
        <div nzFlex="40" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box" style="width: 100%">
            <div class="form-label">
              Date Range<span class="required-color">*</span>
            </div>
            <nz-range-picker
              [(ngModel)]="range"
              [nzFormat]="dateFormat"
            ></nz-range-picker>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 29 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 29 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 29 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 29 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 29 ) || (
        fltrsdata[5] && fltrsdata[5].fltr_id == 29 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 29 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 29 ) || ( fltrsdata[8] && fltrsdata[8].fltr_id == 29 )) ) {
        <div nzFlex="30" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box" style="width: 100%">
            <div class="form-label">
              Date and Time<span class="required-color">*</span>
            </div>
            <!-- <nz-date-picker nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss" [(ngModel)]="dateTime" (ngModelChange)="onChange($event)"></nz-date-picker> -->
            <nz-range-picker
              [nzShowTime]="{ nzFormat: 'HH:mm:ss' }"
              [(ngModel)]="dateTime"
              nzFormat="yyyy-MM-dd HH:mm:ss"
            ></nz-range-picker>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 8 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 8 ) || ( fltrsdata[2] && fltrsdata[2].fltr_id
        == 8 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id == 8 ) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 8 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 8 ) || ( fltrsdata[6] && fltrsdata[6].fltr_id ==
        8 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id == 8 ) || ( fltrsdata[8]
        && fltrsdata[8].fltr_id == 8 ))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Month</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="slctdmnth"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="Month is required!"
            >
              @for (mn of months; track mn) {
              <nz-option [nzValue]="mn.mnth_id" [nzLabel]="mn.mnth_nm">
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 7 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 7 ) || ( fltrsdata[2] && fltrsdata[2].fltr_id
        == 7 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id == 7 ) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 7 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Year</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="slctdyear"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="Year is required!"
            >
              @for (yr of year; track yr) {
              <nz-option [nzValue]="yr.yr_id" [nzLabel]="yr.yr_nm"> </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 2000003 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 2000003 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 2000003 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 2000003 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 2000003 )||( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 2000003 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 2000003 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 2000003 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 2000003 ) || ( fltrsdata[9] &&
        fltrsdata[9].fltr_id == 2000003 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">
              Select Time<span class="required-color">*</span>
            </div>
            <nz-time-picker
              [(ngModel)]="time"
              [nzFormat]="timeFormat"
            ></nz-time-picker>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 28 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 28 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 28 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 28 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 28 )|| (
        fltrsdata[5] && fltrsdata[5].fltr_id == 28 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 28 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 28 ) || ( fltrsdata[8] && fltrsdata[8].fltr_id == 28 )|| (
        fltrsdata[9] && fltrsdata[9].fltr_id == 28 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8">
          <div class="filter-box">
            <div class="form-label">Select Category</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectalrtCat"
              nzPlaceHolder="Choose"
              [nzMaxTagCount]="1"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
            >
              @for (c of alrtCatLst; track c) {
              <nz-option [nzValue]="c.alert_cat_id" [nzLabel]="c.alert_cat_cd">
                {{ c.alert_cat_cd }}
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 32) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 32) || ( fltrsdata[2] && fltrsdata[2].fltr_id
        == 32) || ( fltrsdata[3] && fltrsdata[3].fltr_id == 32) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 32) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 32) || ( fltrsdata[6] && fltrsdata[6].fltr_id ==
        32) || ( fltrsdata[7] && fltrsdata[7].fltr_id == 32) || ( fltrsdata[8]
        && fltrsdata[8].fltr_id == 32))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Vehicle Category</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedCtgry"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="Vehicle is required!"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of asrtCtgryLst; track v) {
              <nz-option
                [nzValue]="v.asrt_ctgry_id"
                [nzLabel]="v.asrt_ctgry_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 27 ) || ( fltrsdata[1]
        && fltrsdata[1].fltr_id == 27 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 27 ) || ( fltrsdata[3] && fltrsdata[3].fltr_id
        == 27 ) || ( fltrsdata[4] && fltrsdata[4].fltr_id == 27 ) || (
        fltrsdata[5] && fltrsdata[5].fltr_id == 27 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 27 ) || ( fltrsdata[7] && fltrsdata[7].fltr_id
        == 27 ) || ( fltrsdata[8] && fltrsdata[8].fltr_id == 27 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Vehicle</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedasrt"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="Vehicle is required!"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of asrtList; track v) {
              <nz-option
                [nzValue]="v.asrt_id"
                [nzLabel]="v.asrt_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 30 &&
        fltrsdata[0].fltr_sqnce_id%2==1) || ( fltrsdata[1] &&
        fltrsdata[1].fltr_id == 30 && fltrsdata[1].fltr_sqnce_id%2==1) || (
        fltrsdata[2] && fltrsdata[2].fltr_id == 30 &&
        fltrsdata[2].fltr_sqnce_id%2==1) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 30 && fltrsdata[3].fltr_sqnce_id%2==1) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 30 &&
        fltrsdata[4].fltr_sqnce_id%2==1) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 30 && fltrsdata[5].fltr_sqnce_id%2==1) || (
        fltrsdata[6] && fltrsdata[6].fltr_id == 30 &&
        fltrsdata[6].fltr_sqnce_id%2==1) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 30 && fltrsdata[7].fltr_sqnce_id%2==1) || (
        fltrsdata[8] && fltrsdata[8].fltr_id == 30 &&
        fltrsdata[8].fltr_sqnce_id%2==1))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Start Location</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="strtLoc"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="Start Location is required!"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of tripLoctns; track v) {
              <nz-option
                [nzValue]="v.strt_fnce_id"
                [nzLabel]="v.strt_fnce_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 30 &&
        fltrsdata[0].fltr_sqnce_id%2==0) || ( fltrsdata[1] &&
        fltrsdata[1].fltr_id == 30 && fltrsdata[1].fltr_sqnce_id%2==0) || (
        fltrsdata[2] && fltrsdata[2].fltr_id == 30 &&
        fltrsdata[2].fltr_sqnce_id%2==0) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 30 && fltrsdata[3].fltr_sqnce_id%2==0) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 30 &&
        fltrsdata[4].fltr_sqnce_id%2==0) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 30 && fltrsdata[5].fltr_sqnce_id%2==0) || (
        fltrsdata[6] && fltrsdata[6].fltr_id == 30 &&
        fltrsdata[6].fltr_sqnce_id%2==0) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 30 && fltrsdata[7].fltr_sqnce_id%2==0) || (
        fltrsdata[8] && fltrsdata[8].fltr_id == 30 &&
        fltrsdata[8].fltr_sqnce_id%2==0))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select End Location</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="endLoc"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="End Location is required!"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of tripEndLoctns; track v) {
              <nz-option
                [nzValue]="v.end_fnce_id"
                [nzLabel]="v.end_fnce_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 30 &&
        fltrsdata[0].fltr_sqnce_id%2==0) || ( fltrsdata[1] &&
        fltrsdata[1].fltr_id == 30 && fltrsdata[1].fltr_sqnce_id%2==0) || (
        fltrsdata[2] && fltrsdata[2].fltr_id == 30 &&
        fltrsdata[2].fltr_sqnce_id%2==0) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 30 && fltrsdata[3].fltr_sqnce_id%2==0) || (
        fltrsdata[4] && fltrsdata[4].fltr_id == 30 &&
        fltrsdata[4].fltr_sqnce_id%2==0) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 30 && fltrsdata[5].fltr_sqnce_id%2==0) || (
        fltrsdata[6] && fltrsdata[6].fltr_id == 30 &&
        fltrsdata[6].fltr_sqnce_id%2==0) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 30 && fltrsdata[7].fltr_sqnce_id%2==0) || (
        fltrsdata[8] && fltrsdata[8].fltr_id == 30 &&
        fltrsdata[8].fltr_sqnce_id%2==0))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select End Location</div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="endLoc"
              nzPlaceHolder="Choose"
              [ngModelOptions]="{ standalone: true }"
              nzErrorTip="End Location is required!"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of tripEndLoctns; track v) {
              <nz-option
                [nzValue]="v.end_fnce_id"
                [nzLabel]="v.end_fnce_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 2000006 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 2000006 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 2000006 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 2000006 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 2000006 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 2000006 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 2000006 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 2000006 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 2000006 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Vehicle</div>
            <nz-select
              [nzMaxTagCount]="2"
              [nzMaxTagPlaceholder]="tagPlaceHolder"
              nzMode="multiple"
              nzPlaceHolder="Please select"
              [(ngModel)]="selectedvehcls"
              style="width: 300px; margin-right: 15px"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of asrtList; track v) {
              <nz-option
                [nzValue]="v.asrt_id"
                [nzLabel]="v.asrt_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 3000000 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 3000000 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 3000000 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 3000000 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 3000000 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 3000000 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 3000000 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 3000000 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 2000006 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Vehicle Group</div>
            <nz-select
              nzPlaceHolder="Please select"
              [(ngModel)]="group"
              style="width: 300px; margin-right: 15px"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of asrtGrps; track v) {
              <nz-option
                [nzValue]="v.asrt_grp_id"
                [nzLabel]="v.asrt_grp_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 2000009 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 2000009 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 2000009 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 2000009 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 2000009 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 2000009 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 2000009 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 2000009 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 2000009 ) )) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Stoppage Time</div>
            <nz-select
              nzPlaceHolder="Please select"
              [(ngModel)]="stpg_tm"
              style="width: 300px; margin-right: 15px"
            >
              <!-- <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option> -->
              @for (v of stpgTmeLst; track v) {
              <nz-option
                [nzValue]="v.stpg_tme_id"
                [nzLabel]="v.stpg_dsply_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        } @if ((( fltrsdata[0] && fltrsdata[0].fltr_id == 4000000 ) || (
        fltrsdata[1] && fltrsdata[1].fltr_id == 4000000 ) || ( fltrsdata[2] &&
        fltrsdata[2].fltr_id == 4000000 ) || ( fltrsdata[3] &&
        fltrsdata[3].fltr_id == 4000000 ) || ( fltrsdata[4] &&
        fltrsdata[4].fltr_id == 4000000 ) || ( fltrsdata[5] &&
        fltrsdata[5].fltr_id == 4000000 ) || ( fltrsdata[6] &&
        fltrsdata[6].fltr_id == 4000000 ) || ( fltrsdata[7] &&
        fltrsdata[7].fltr_id == 4000000 ) || ( fltrsdata[8] &&
        fltrsdata[8].fltr_id == 4000000 ) || ( fltrsdata[9] &&
        fltrsdata[9].fltr_id == 4000000 ) || ( fltrsdata[10] &&
        fltrsdata[10].fltr_id == 4000000 ) || ( fltrsdata[11] &&
        fltrsdata[11].fltr_id == 4000000 ) || ( fltrsdata[12] &&
        fltrsdata[12].fltr_id == 4000000 ) || ( fltrsdata[13] &&
        fltrsdata[13].fltr_id == 4000000 ) || ( fltrsdata[14] &&
        fltrsdata[14].fltr_id == 4000000 ) || ( fltrsdata[15] &&
        fltrsdata[15].fltr_id == 4000000 ) || ( fltrsdata[16] &&
        fltrsdata[16].fltr_id == 4000000 ) || ( fltrsdata[17] &&
        fltrsdata[17].fltr_id == 4000000 ) || ( fltrsdata[18] &&
        fltrsdata[18].fltr_id == 4000000 ) || ( fltrsdata[19] &&
        fltrsdata[19].fltr_id == 4000000 ) || ( fltrsdata[20] &&
        fltrsdata[20].fltr_id == 4000000 ) || ( fltrsdata[21] &&
        fltrsdata[21].fltr_id == 4000000 ))) {
        <div nzFlex="20" nzFlex.xs="100" class="px-8" nzOffset="2">
          <div class="filter-box">
            <div class="form-label">Select Trip Type</div>
            <nz-select
              nzPlaceHolder="Please select"
              [(ngModel)]="trip_type"
              style="width: 300px; margin-right: 15px"
            >
              <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
              @for (v of tripTypeLst; track v) {
              <nz-option
                [nzValue]="v.trp_type_id"
                [nzLabel]="v.trp_type_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
        </div>
        }
        <div
          nzFlex="20"
          nzFlex.xs="100"
          class="px-8"
          nzOffset="4"
          style="margin-top: 18px; margin-left: 109px"
        >
          <button nz-button nzType="primary" (click)="getRports()">
            Get Data
          </button>
        </div>
      </div>
    </div>
  </div>
  }
</div>
} @if (!shwmsg && !loader && rpt_id==184) {
<div class="row align-items-md-center">
  <div class="col-md-12">
    <div
      style="
        position: absolute;
        right: 400px;
        top: 14px;
        z-index: 1;
        border-radius: 5px;
        color: black;
        cursor: pointer;
        font-size: 20px;
        font-weight: 600;
        padding: 7px;
      "
    >
      O:&nbsp;<span>Operated</span>&nbsp;&nbsp;&nbsp;N:&nbsp;<span
        >Not Operated</span
      >
    </div>
  </div>
</div>
} @if (!shwmsg && !loader) {
<div class="row align-items-md-center">
  <div class="col-md-12"></div>
</div>
} @if (shwmsg) {
<div>
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You Don't Have Access To View This Report"
  >
    <div nz-result-extra>
      <button nz-button nzType="primary" (click)="gotorpt()">
        Go to reports
      </button>
    </div>
  </nz-result>
</div>
} @if (rpt_id==2000011) {
<div class="row">
  @for (s of asrtStsList; track s) {
  <div>
    <span style="padding: 4px; margin: 4px">
      {{ s.asr_sts_clr_cd }} : {{ s.asrt_sts_nm }}
    </span>
  </div>
  }
</div>
} @if (!(shwmsg) && fltrsdata.length && rpt_id!=1000020) {
<div nz-row class="gridTop bluhdrgrid">
  @if (loader) {
  <ds-loading></ds-loading>
  }
  <div
    class="ds-card grid"
    style="height: calc(100vh - 200px); display: flex; flex-direction: column"
  >
    <app-data-grid
      [toolbarItems]="pdfToolbar"
      [groupItems]="gridGroupItems"
      id="gridContainer"
      style="width: 100%; height: 100%"
      [dataSource]="rowData"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="fltrsdata[0].excel_in == 1 ? true : false"
      [exportFileName]="fltrsdata[0].excel_nm"
      [pageSize]="fltrsdata[0].pagination"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
      (cellClick)="devCellclk(columnDefs, $event)"
      [cellPrepared]="bound_onCellPrepared"
    >
      <ng-template appGridCell="prfleTemplate2" let-data="cell"
        ><div>
          <div class="cursor-pointer tblPrfleBtn" (click)="viewLocation(data)">
            <span nz-icon nzType="environment" nzTheme="outline"></span>
          </div></div
      ></ng-template>
    </app-data-grid>
  </div>
</div>
} @if (rpt_id==1000020) {
<div nz-row class="gridTop">
  @if (loader) {
  <ds-loading></ds-loading>
  }
  <div
    class="ds-card grid"
    style="height: calc(100vh - 200px); display: flex; flex-direction: column"
  >
    <app-data-grid
      [groupItems]="gridGroupItems"
      id="gridContainer"
      style="width: 100%; height: 100%"
      [dataSource]="rowData"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="fltrsdata[0].excel_in == 1 ? true : false"
      [exportFileName]="fltrsdata[0].excel_nm"
      [pageSize]="fltrsdata[0].pagination"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
      (cellClick)="devCellclk(columnDefs, $event)"
      [cellPrepared]="bound_onCellPrepared"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [width]="100"
        caption="Image Before Cleaning"
        cellTemplate="prfleTemplate1"
      ></app-grid-column>
      <ng-template appGridCell="prfleTemplate1" let-data="cell"
        ><div>
          <div class="cursor-pointer tblPrfleBtn" (click)="getimage(data)">
            <span nz-icon nzType="picture" nzTheme="outline"></span>
          </div></div
      ></ng-template>
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [width]="100"
        caption="Image After Cleaning"
        cellTemplate="prfleTemplate2"
      ></app-grid-column>
      <ng-template appGridCell="prfleTemplate2" let-data="cell"
        ><div>
          <div class="cursor-pointer tblPrfleBtn" (click)="getimage2(data)">
            <span nz-icon nzType="picture" nzTheme="outline"></span>
          </div></div
      ></ng-template>
    </app-data-grid>
  </div>
</div>
}
